import React from 'react';

import { Typography } from 'antd';

import { TimelineItem } from './api';
import SoloOutcome from './SoloOutcome';

/** What a room without a grade is waiting for — or that it is not waiting. */
const STATUS_NOTES: { [status: string]: string } = {
  in_progress:
    'Still in progress — the grade lands when the session finishes and is scored.',
  finished_ungraded:
    'Grading is under way. The result appears here when it finishes.',
  deferred: 'Your responses are saved. Results pending review.',
  not_graded: 'This mini session was not graded.',
};

/**
 * The result of a solo (IDG) room — overlaid on the skill tree.
 *
 * Titled "Result", never "Grading": "Grading · Failed" read as the grading
 * itself having failed. No rank row: IDG mini-session presentation
 * deliberately omits ranks.
 */
const SoloGradingCard: React.FC<{ item: TimelineItem }> = ({ item }) => {
  const note = item.status ? STATUS_NOTES[item.status] : undefined;
  return (
    <div className="cstudio__grading-card">
      <div className="cstudio__panel-card-head">
        <span className="cstudio__panel-card-title">Result</span>
      </div>
      <div className="cstudio__inspect-summary cstudio__grading-card-body">
        <div className="cstudio__summary-row">
          <span className="cstudio__tile-label">Mini session</span>
          <span>{item.mini_session_name ?? '—'}</span>
        </div>
        <SoloOutcome
          item={{
            status: item.status,
            score_pct: item.score_pct ?? null,
            pass_bar: item.pass_bar ?? null,
            conviction_coverage: item.conviction_coverage,
          }}
        />
        {note && (
          <Typography.Text type="secondary" style={{ fontSize: 11 }}>
            {note}
          </Typography.Text>
        )}
      </div>
    </div>
  );
};

export default SoloGradingCard;
